import { useEffect, useState } from "react";

import { useAppDispatch, useAppSelector } from "@app/store";
import { PARAMS } from "@constants/index";
import { FilterParams } from "types";
import { useDeleteTeamMutation, useLazyGetTeamsQuery } from "@modules/team";
import { useUpdateTeamConfigurationMutation } from "@modules/team/api/team.api";
import { setTeams } from "@modules/team/store/team.slice";

export const useTeamListLogic = () => {
  const dispatch = useAppDispatch();
  const teamList = useAppSelector((state) => state.team.teams)

  const [getTeams] = useLazyGetTeamsQuery()
  const [deleteTeam] = useDeleteTeamMutation()
  const [updateConfiguratuin] = useUpdateTeamConfigurationMutation()

  const [pagesCount, setPagesCount] = useState(1);
  const [filters, setFilters] = useState<FilterParams>({ limit: PARAMS.LIMIT, offset: PARAMS.OFFSET })

  const handleGetRequest = async () => {
    try {
      const responseTeams = await getTeams(filters).unwrap();

      dispatch(setTeams(responseTeams.teams));
      setPagesCount(responseTeams.count || 1)
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteTeam = async (id: string) => {
    try {
      if (!id) {
        return null
      }

      await deleteTeam({ id })
      handleGetRequest()
    } catch (error) {
      console.log(error);
    }
  }

  const handlePagination = (page: number, limit: number) => {
    const offset = page === 1 ? PARAMS.OFFSET : limit * (page - 1)

    setFilters({ limit, offset })
  }

  useEffect(() => {
    handleGetRequest()
  }, [filters])

  return {
    teamList,
    pagesCount,
    handleDeleteTeam,
    handlePagination
  }
}
